import react from 'react';
import FooterLogo from '../images/humanitynestLogo.jpeg';
import { FaXTwitter } from 'react-icons/fa6';
import { RiFacebookFill } from 'react-icons/ri';
import { FaInstagram } from 'react-icons/fa6';
import { CiYoutube } from 'react-icons/ci';
import { MdAlternateEmail } from 'react-icons/md';
import { FaLocationArrow } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const Footer = () => {
	return (
		<div className='lg:w-full sm:h-[832px] lg:h-[463px] md:h-[463px] bg-black text-white'>
			<div className='lg:mx-[156px] lg:my-[145px] lg:flex md:flex m-[24px] md:justify-between lg:justify-between pb-[98px] lg:pb-0'>
				<div className='lg:mb-[20px] mb-[20px] mt-[95px] lg:mt-0'>
					<NavLink to='/' className=''>
						<img src={FooterLogo} className='w-[136px]' />
					</NavLink>

					<div className='flex gap-x-0.5 mt-6'>
						<a href='https://x.com/humanitynest?t=vvnH8mtP5lPmmov3w4M0wA&s=09'>
							<div className='w-[43px] h-[43px] border b-1 border-[#313131] rounded-lg flex items-center'>
								<FaXTwitter className='mx-auto' style={{ fontSize: '30px' }} />
							</div>
						</a>
						<a href='https://www.facebook.com/share/1CNsTAMVV6/'>
							<div className='w-[43px] h-[43px] border b-1 border-[#313131] rounded-lg flex items-center'>
								<RiFacebookFill
									className='mx-auto'
									style={{ fontSize: '30px' }}
								/>
							</div>
						</a>

						<a href='https://www.instagram.com/humanitynest?igsh=d2JscGtlb2tibnRj'>
							<div className='w-[43px] h-[43px] border b-1 border-[#313131] rounded-lg flex items-center'>
								<FaInstagram className='mx-auto' style={{ fontSize: '30px' }} />
							</div>
						</a>
						<a href='https://youtube.com/@humanitynest?si=5gtMa93d14M-MucM'>
							<div className='w-[43px] h-[43px] border b-1 border-[#313131] rounded-lg flex items-center'>
								<CiYoutube className='mx-auto' style={{ fontSize: '30px' }} />
							</div>
						</a>
					</div>
					<div className='w-[197px] text-[13px] mt-6'>
						<p>Copyright © 2025 humanitynest Foundation - All Rights Reserved.</p>
					</div>
				</div>

				<div className='text-white/[0.7] lg:mt-0'>
					<p className='mb-[20px] text-[#A8A8A8]'>Reach us via</p>
					<div className='flex gap-x-2 items-center'>
						<MdAlternateEmail />
						<p className='mb-3 pt-3'>humanitynestsocial@gmail.com 
</p>
					</div>
					<div className='flex gap-x-2 items-center'>
						<FaLocationArrow />
						<p className='mb-3 pt-3'>09164155249</p>
					</div>
				</div>
				<div className='text-white/[0.7] lg:mt-0'>
					<p className=' text-[#A8A8A8]'>Address</p>
					
					<div className='flex gap-x-2 items-center'>
						<FaLocationArrow />
						<p className='mb-3 pt-3'>Address: No 100 Ada George Road Port Harcourt Rivers Nigeria</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
